import { render, staticRenderFns } from "./PhoneListTooltip.vue?vue&type=template&id=45de470c&scoped=true"
import script from "./PhoneListTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneListTooltip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PhoneListTooltip.vue?vue&type=style&index=0&id=45de470c&lang=scss&scoped=true"
import style1 from "./PhoneListTooltip.vue?vue&type=style&index=1&id=45de470c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de470c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45de470c')) {
      api.createRecord('45de470c', component.options)
    } else {
      api.reload('45de470c', component.options)
    }
    module.hot.accept("./PhoneListTooltip.vue?vue&type=template&id=45de470c&scoped=true", function () {
      api.rerender('45de470c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientSummaryWidget/PhoneListTooltip.vue"
export default component.exports